import { FormWithPasswordMeter } from './PasswordForms/FormWithPasswordMeter';
import { useSelector } from 'react-redux';
import { RootState, changePassword } from '../../store/index';

const ChangePassword = () => {
    const localization = useSelector(
        (state: RootState) =>
            state.localization.localizationStrings.susy.authentication
                .changePassword
    );

    return (
        <>
            <FormWithPasswordMeter
                buttonText={localization.changePasswordButton}
                onSubmit={async (
                    password: string,
                    repeatedPassword?: string,
                    oldPassword?: string
                ) =>
                    await changePassword({
                        oldPassword: oldPassword ?? '',
                        newPassword: password,
                        newPasswordRepeat: repeatedPassword ?? '',
                    })
                }
                title={localization.changePasswordTitle}
                subtitle={localization.changePasswordSubtitle}
                oldPasswordRequired
                wideForm
            />
        </>
    );
};

export default ChangePassword;
